<template>
  <div class="sel-modal clearfix">
    <div v-if="isShowDetail">
      <div class="sel-modal-header clearfix">
        <vxe-radio-group v-model="selectTab" @change="handleTabClick">
          <ul class="tab-list">
            <li>
              <vxe-radio name="name1" label="tab1">基本信息</vxe-radio>
            </li>
            <li v-if="edit">
              <vxe-radio name="name2" label="tab2">银行账户</vxe-radio>
            </li>
            <li v-if="edit">
              <vxe-radio name="name3" label="tab3">邮寄地址</vxe-radio>
            </li>
            <li v-if="edit">
              <vxe-radio name="name4" label="tab4">子账户</vxe-radio>
            </li>
            <li v-if="edit">
              <vxe-radio name="name5" label="tab5">线上支付设置</vxe-radio>
            </li>
            <li v-if="(userType === 2  && isHavePermission('user:company:dataShare')) || (userType === 1 && isHavePermission('user:person:dataShare')) && edit">
              <vxe-radio name="name6" label="tab6">共享设置</vxe-radio>
            </li>
          </ul>
        </vxe-radio-group>
      </div>
      <div v-show="selectTab === 'tab1'">
        <user-detail
            ref="userInfo"
            :userId="userId"
            :isUserEdit="isUserEdit"
            :edit="edit"
            :salesManName="salesManName"
            @submitC="submitC"
            @resStatus="getResStatus"
        ></user-detail>
      </div>
      <div v-show="selectTab === 'tab2'">
        <bank-account ref="bankAccount" :userId="userId" :realName="userName"></bank-account>
      </div>
      <div v-show="selectTab === 'tab3'">
        <mail-address ref="mailAddress" :userId="userId"></mail-address>
      </div>
      <div v-show="selectTab === 'tab4'">
        <company-info
            ref="companyInfo"
            :userId="userId"
            :accType="userType"
        ></company-info>
      </div>
      <div v-show="selectTab === 'tab5'" v-if="isHavePermission('userDetail:traOnlinePay')">
        <tra-online-pay :userId="userId" :userName="userName"></tra-online-pay>
      </div>
      <div v-show="selectTab === 'tab6'">
        <data-share :userId="userId" ref="dataShare"></data-share>
      </div>
    </div>
    <div class="no-permission" v-else>
      <div class="no-permission-bg"></div>
      <div class="no-permission-txt">您无查看权限</div>
    </div>
  </div>
  <!--  <div class="userList">-->
  <!--    <Tabs value="name1" @on-click="handleTabClick">-->
  <!--      <TabPane label="基本信息" name="name1">-->
  <!--        <user-detail ref="userInfo" :userId =userId :isUserEdit = isUserEdit :salesManName ="salesManName"  @submitC = submitC></user-detail>-->
  <!--      </TabPane>-->
  <!--      <TabPane label="银行账户" name="name2">-->
  <!--        <bank-account ref="bankAccount" :userId=userId></bank-account>-->
  <!--      </TabPane>-->
  <!--      <TabPane label="邮寄地址" name="name3">-->
  <!--        <mail-address ref="mailAddress" :userId=userId></mail-address>-->
  <!--      </TabPane>-->
  <!--      <TabPane label="子账户" name="name4">-->
  <!--        <company-info ref="companyInfo" :userId=userId :accType=userType :userName=userName></company-info>-->
  <!--      </TabPane>-->
  <!--    </Tabs>-->
  <!--    &lt;!&ndash; <Modal v-model="userInfoModal" width="900" title="查看用户信息">-->
  <!--      <user-detail ref="userInfo"></user-detail>-->
  <!--    </Modal> &ndash;&gt;-->
  <!--  </div>-->
</template>

<script>
import md5 from "js-md5";
import $api from "@/apiProvider";
import getAuthOrization from "@/mixin/getAuthOrization";
import BankAccount from "@/views/account/BankAccount";
import MailAddress from "@/views/account/MailAddress";
import UserDetail from "@/views/account/UserDetail";
import CompanyInfo from "@/views/account/CompanyInfo";
import TraOnlinePay from "./TraOnlinePay";
import {showLoading, hideLoading} from "@/utils/util";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import auth from "@/utils/auth";
import DataShare from "@/views/account/DataShare";

export default {
  components: {UserDetail, BankAccount, MailAddress, CompanyInfo, TraOnlinePay, DataShare},
  mixins: [getAuthOrization],
  props: {
    userId: Number,
    userType: Number,
    isUserEdit: Boolean,
    userName: String,
    salesManName: String,
    edit: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    const realNameValid = ({cellValue}) => {
      if (this.editFormData.userType == 1) {
        if (this.editFormData.realName == null || this.editFormData.realName == "") {
          return Promise.reject(new Error("请输入姓名"));
        }
      }
    };
    const newPwdValid = ({cellValue}) => {
      if (this.accountData.password != null && this.accountData.password != "") {
        if (this.accountData.newPassword !== this.accountData.password) {
          this.isTrue2 = false;
          return Promise.reject(new Error("两次输入密码不一致"));
        } else {
          this.isTrue2 = true;
        }
      }
    };
    // const regNumber = /(?=.*([a-zA-Z].*))(?=.*[0-9].*)[a-zA-Z0-9-*/+.~!@#$%^&*()]{8,}$/;
    // const pwdValid = ({ cellValue }) => {
    //   if (!regNumber.test(this.accountData.password)) {
    //     this.isTrue = false;
    //     this.isTrue2 = false;
    //     return Promise.reject(
    //       new Error("密码须包含数字和英文字母，长度不少于8个字符")
    //     );
    //   } else {
    //     this.isTrue = true;
    //   }
    // };

    return {
      selectTab: "tab1",
      current: 1,
      current2: 1,
      pageSize: 10,
      compTotal: 50,
      userTotal: 50,
      uploadHeaders: {
        Authorization: auth.getAuth().token,
        token: auth.getAuth().token,
      },
      createAccountModal: false,
      editUserInfoModal: false,
      userInfoModal: false,
      isTrue: false,
      isTrue2: false,
      name1: "name1",
      isEdit: true,
      compList: [],
      userList: [],
      tableData: [
        {
          accountName: 12,
          accountNum: 123,
          bankName: 1234,
        },
        {
          accountName: 123,
          accountNum: 1234,
          bankName: 12345,
        },
        {
          accountName: 1234,
          accountNum: 12345,
          bankName: 123456,
        },
      ],
      // {
      //   linkMan: "联系人1",
      //   linkPhone: "联系电话1",
      //   content: "地址1"
      // },
      // {
      //   linkMan: "联系人2",
      //   linkPhone: "联系电话2",
      //   content: "地址2"
      // },
      // {
      //   linkMan: "联系人3",
      //   linkPhone: "联系电话3",
      //   content: "地址3"
      // }
      listQuery: {
        page: 1,
        rows: 10,
        userType: 2,
        userName: null,
        orderBy: 2,
        isDesc: 1,
      },

      editFormData: {},
      accountData: {
        id: null,
        password: null,
        userName: null,
      },
      accountDataCopy: {},
      formRules: {
        nickname: [{required: true, message: "请输入昵称"}],
        compName: [{required: true, message: "请输入公司名称"}],
        realName: [{validator: realNameValid}],
      },
      formRules2: {
        userName: [{required: true, message: "请输入名称"}],
        password: [
          // { required: true, message: "请输入密码" },
          {min: 6, message: "密码长度不少于6个字符"},
        ],
        newPassword: [
          // { required: true, message: "请再输入密码" },
          {validator: newPwdValid},
        ],
      },
      isShowDetail: true
    };
  },
  watch: {
    $route() {
      this.getList();
    },
    userId(val) {
      if (val !== 0) {
        this.$refs.userInfo.getDetail(this.userId);
      }
    },
  },
  created() {
    this.getList();
    console.log(this.userId, "111111111");
    console.log(this.userType, "/22222");
    this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
  },
  // mounted(){
  //     this.$refs.userInfo.getDetail(this.userId);

  // },
  methods: {
    getResStatus(status) {
      this.isShowDetail = status === 10009 ? false : true;
    },
    addUser() {
      this.$router.push("/user/createUser");
    },
    change(val) {
      this.listQuery.page = val.currentPage;
      this.listQuery.rows = val.pageSize;
      this.getList();
      console.log(this.listQuery);
    },
    change2(val) {
      this.listQuery.page = val.currentPage;
      this.listQuery.rows = val.pageSize;
      this.getList();
      console.log(this.listQuery);
    },
    copyDeep(templateData) {
      // templateData 是要复制的数组或对象，这样的数组或者对象就是指向新的地址的
      return JSON.parse(JSON.stringify(templateData));
    },
    submitPassword() {
      if (
          !this.isTrue2 &&
          (this.accountData.password != null && this.accountData.password != "") &
          (this.accountData.newPassword == null || this.accountData.newPassword == "")
      ) {
        this.$XModal.alert({
          message: "请确认密码",
          status: "error",
        });
        this.loading = false;
        return;
      }

      this.copyPasswordTemp();
      let data = this.accountDataCopy;
      new Promise((resolve, reject) => {
        $api.gcdUser.updateUserPassModel
            .POST({
              data,
            })
            .then((res) => {
              if (res.status == 1) {
                this.$Message["success"]({
                  background: true,
                  content: "更新成功",
                });
                this.createAccountModal = false;
                this.getList();
              } else {
                this.$XModal.alert({
                  message: res.message ? res.message : "接口异常",
                  status: "error",
                });
                this.loading = false;
              }
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
      });
    },
    submitEditUser() {
      this.loading = true;
      let self = this;
      if (
          this.editFormData.userType == 1 &&
          (this.editFormData.realName == null || this.editFormData.realName == "")
      ) {
        this.$XModal.alert({
          message: "请输入姓名",
          status: "error",
        });
        this.loading = false;
        return;
      }
      if (
          this.editFormData.userType == 2 &&
          (this.editFormData.compName == null || this.editFormData.compName == "")
      ) {
        this.$XModal.alert({
          message: "请输入公司名称",
          status: "error",
        });
        this.loading = false;
        return;
      }
      self.copyTemp();
      let data = self.editFormDataCopy;
      console.log(data);
      new Promise((resolve, reject) => {
        showLoading();
        $api.gcdUser.addGcdUserModel
            .POST({
              data,
            })
            .then((response) => {
              hideLoading();
              if (response.status == 1) {
                this.$Message["success"]({
                  background: true,
                  content: "更新成功",
                });
                this.getList();
                this.editUserInfoModal = false;
              } else {
                this.$XModal.alert({
                  message: response.message ? response.message : "接口异常",
                  status: "error",
                });
                this.loading = false;
              }
            })
            .catch(function (er) {
              console.log(er.response.data.message);
              self.$XModal.alert({
                message: er.response.data.message ? er.response.data.message : "接口异常",
                status: "error",
              });
              return;
            });
      });
    },
    handleTabClick(val) {
      let label = val.label;
      if (label === "tab1") {
        this.$refs.userInfo.getDetail(this.userId);
      }
      if (label === "tab2") {
        this.$refs.bankAccount.queryUserBankList(this.userId);
      }
      if (label === "tab3") {
        this.$refs.mailAddress.queryUserAddressList(this.userId);
      }
      if (label === "tab6") {
        this.$refs.dataShare.init(this.userId);
      }
    },
    getList() {
      let data = this.listQuery;
      new Promise((resolve, reject) => {
        $api.gcdUser.queryGcdUserListModel
            .POST({
              data,
            })
            .then((response) => {
              if (response.status == 1) {
                let res = response.data;
                if (this.listQuery.userType == 1) {
                  this.userList = res.rows;
                  this.userTotal = res.total;
                }
                if (this.listQuery.userType == 2) {
                  this.compList = res.rows;
                  this.compTotal = res.total;
                }
              } else {
                this.$XModal.alert({
                  message: response.message ? response.message : "接口异常",
                  status: "error",
                });
              }
            })
            .catch((error) => {
              reject(error);
            });
      });
    },
    userInfo(row) {
      this.$refs.userInfo.getDetail(row.id);
      this.userInfoModal = true;
    },
    insertEvent(row) {
      let record = {};
      this.$refs.xBankTable.insertAt(record, row);
    },
    insertEvent2(row) {
      let record = {};
      this.$refs.xEmailTable.insertAt(record, row);
    },
    delRow(e) {
      console.log(e);
      this.$refs.xBankTable.remove(e);
    },
    delRow2(e) {
      console.log(e);
      this.$refs.xEmailTable.remove(e);
    },
    delUser(row) {
      this.$XModal.confirm("您确定要删除吗？").then((type) => {
        if (type === "confirm") {
          this.commitDel(row);
        }
      });
    },
    delSalesMan(row) {
      this.$XModal.confirm("您确定要移除业务员吗？").then((type) => {
        if (type === "confirm") {
          this.commitDelSalesMan(row);
        }
      });
    },
    commitDel(row) {
      var data = {
        id: row.id,
      };
      new Promise((resolve, reject) => {
        $api.gcdUser.delGcdUserModel
            .POST({
              data,
            })
            .then((res) => {
              if (res.status == 1) {
                this.$Message["success"]({
                  background: true,
                  content: "删除成功",
                });
                this.getList();
              } else {
                this.$XModal.alert({
                  message: res.message ? res.message : "接口异常",
                  status: "error",
                });
                this.loading = false;
              }
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
      });
    },
    editUserInfo(row) {
      var data = {
        id: row.id,
      };
      console.log(data);
      new Promise((resolve, reject) => {
        $api.gcdUser.queryGcdUserModel
            .POST({
              data,
            })
            .then((response) => {
              this.editFormData = response.data;
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
      });
      this.editUserInfoModal = true;
    },
    editUserPassword(row) {
      this.accountData = {};
      this.accountData.userName = row.userName;
      this.accountData.id = row.id;

      this.createAccountModal = true;
    },
    copyPasswordTemp() {
      this.accountDataCopy = {};
      this.accountDataCopy.id = this.accountData.id;
      this.accountDataCopy.userName = this.accountData.userName;

      if (this.accountData.password == null || this.accountData.password == "") {
        this.accountDataCopy.password = md5("888999");
      } else {
        this.accountDataCopy.password = md5(this.accountData.password);
      }
    },
    submitC(val) {
      if (val) {
        this.$emit("submitC", true);
      }
    },
    handleRemove(i) {
      // const fileList = this.$refs.upload.fileList;
      // this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
      this.$XModal.confirm("您确定要删除该附件吗？").then((type) => {
        if (type === "confirm") {
          if (i == "idcardBackUrl") {
            this.editFormData.idcardBackUrl = null;
          } else if (i == "idcardFrontUrl") {
            this.editFormData.idcardFrontUrl = null;
          } else if (i == "businessUrl") {
            this.editFormData.businessUrl = null;
          }
        }
      });
    },
    idcardBackUrlLoadfile(res) {
      if (res.status === 200 && res.data) {
        // this.uuidList.push(res.data.uuid);
        var obj = {
          url: res.data.url,
          oldFileName: this.file.name,
          uuid: res.data.uuid,
        };
        this.editFormData.idcardBackUrl = res.data.url;
        this.$nextTick(() => {
          this.initImageTools();
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    idcardFrontUrlLoadfile(res) {
      if (res.status === 200 && res.data) {
        // this.uuidList.push(res.data.uuid);
        var obj = {
          url: res.data.url,
          oldFileName: this.file.name,
          uuid: res.data.uuid,
        };
        this.editFormData.idcardFrontUrl = res.data.url;
        this.$nextTick(() => {
          this.initImageTools();
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    businessUrlLoadfile(res) {
      if (res.status === 200 && res.data) {
        // this.uuidList.push(res.data.uuid);
        var obj = {
          url: res.data.url,
          oldFileName: this.file.name,
          uuid: res.data.uuid,
        };
        this.editFormData.businessUrl = res.data.url;
        this.$nextTick(() => {
          this.initImageTools();
        });
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    destroyViewer() {
      this.viewer ? this.viewer.destroy() : "";
    },
    initImageTools() {
      //初始化 viewerjs
      const ViewerDom = this.$refs.imgbox;
      this.viewer = new Viewer(ViewerDom, {
        url: "data-original",
        toolbar: {
          zoomIn: 1,
          zoomOut: 1,
          reset: 1,
        },
        show: function () {
          this.viewer.update();
        },
      });
    },
    handleUpload(file) {
      // 上传
      this.file = file;
      // this.uploadList = this.$refs.upload.fileList;
      let that = this;
      let reader = new FileReader();
      reader.onload = function (e) {
        that.imgUrl = e.target.result;
      };
      reader.readAsDataURL(file);
      console.log(this.file.name);
    },
    copyTemp() {
      this.editFormDataCopy = {
        userAddressBankInfo: [],
        userAddressInfor: [],
      };
      this.editFormDataCopy.id = this.editFormData.id;
      this.editFormDataCopy.userName = this.editFormData.userName;
      this.editFormDataCopy.accountName = this.editFormData.accountName;
      this.editFormDataCopy.bankName = this.editFormData.bankName;
      this.editFormDataCopy.accountNum = this.editFormData.accountNum;
      this.editFormDataCopy.compName = this.editFormData.compName;
      this.editFormDataCopy.password = this.editFormData.password;
      this.editFormDataCopy.userType = this.editFormData.userType;
      this.editFormDataCopy.realName = this.editFormData.realName;
      this.editFormDataCopy.faxNum = this.editFormData.faxNum;
      this.editFormDataCopy.idcardNum = this.editFormData.idcardNum;
      this.editFormDataCopy.phoneNum = this.editFormData.phoneNum;
      this.editFormDataCopy.regAddr = this.editFormData.regAddr;
      this.editFormDataCopy.regPhone = this.editFormData.regPhone;
      this.editFormDataCopy.taxNum = this.editFormData.taxNum;
      this.editFormDataCopy.idcardBackUrl = this.editFormData.idcardBackUrl;
      this.editFormDataCopy.businessUrl = this.editFormData.businessUrl;
      this.editFormDataCopy.idcardFrontUrl = this.editFormData.idcardFrontUrl;
      this.editFormDataCopy.linkman = this.editFormData.linkman;

      //后端要求传一个字符
      this.editFormDataCopy.password = "password";
      if (this.$refs.xBankTable != null) {
        this.editFormDataCopy.userAddressBankInfo = this.copyDeep(
            this.$refs.xBankTable.getTableData().fullData
        );
      }
      if (this.$refs.xEmailTable != null) {
        this.editFormDataCopy.userAddressInfor = this.copyDeep(
            this.$refs.xEmailTable.getTableData().fullData
        );
      }
    },
    cancelSubmit() {
      this.createAccountModal = false;
      this.editUserInfoModal = false;
    },
  },
};
</script>

<style>
.userList .ivu-card-shadow {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}

.userList .vxe-table th .vxe-cell {
  color: rgb(128, 134, 149);
  font-weight: 400;
}

.pageCss {
  display: flex;
  margin: 10px;
  flex-direction: row-reverse;
}

.userList .ivu-card-body {
  padding: 1px;
}

.userList .ivu-table-wrapper-with-border {
  border: 0px solid #dcdee2;
  border-bottom: 0;
  border-right: 0;
}

.userList .ivu-table-border:after {
  content: "";
  width: 0px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background-color: #dcdee2;
  z-index: 3;
}

.infoPaddingCss .vxe-cell--title .ivu-btn-icon-only,
.infoPaddingCss .vxe-cell .ivu-btn-icon-only {
  width: 20px;
  height: 20px;
  padding: 0;
  font-size: 12px;
  /* border-radius: 4px; */
}

.fontWeight {
  font-weight: 800;
  margin-bottom: 10px;
  display: inline-block;
}

.vxe-form .infoPaddingCss .vxe-form--item {
  display: none;
  padding: 0em 0.8em 0.5em 0;
}

.infoPaddingCss .vxe-input:not(.is--disabled).is--active .vxe-input--inner {
  border: 0px solid #409eff;
}

.infoPaddingCss .vxe-form--item-title {
  padding-left: 10px;
  padding-right: 0em;
}

.infoPaddingCss .vxe-input--inner {
  width: 100%;
  height: 100%;
  /* border-radius: 4px; */
  outline: 0;
  padding: 0 0.6em;
  color: #606266;
  border: 0px solid #dcdfe6;
  background-color: #fff;
  -webkit-box-shadow: none;
  box-shadow: none;
}

/* .flexCss {
    display: flex;
    justify-content: center;
  } */
</style>
